import Link from 'src/components/Link'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

type ProductVerticalCardProps = {
  isBlackFriday?: boolean
  isHotSite?: boolean
  isFavorite?: boolean
  isFluidMobile?: boolean
  isSearchAndCategory?: boolean
}

// Estas flags existem apenas para a folha de estilo. O alvo do styled aqui e um
// COMPONENTE (Link -> next/link) e, nesse caso, o Emotion repassa todas as props
// adiante em vez de filtrar pelos atributos validos de HTML: sem este filtro elas
// chegariam ao <a> e o React avisaria sobre prop desconhecida no DOM. Era por isso
// que antes viviam em lowercase e como string 'true' | 'false' — o lowercase
// escondia o aviso do React e a string era o unico jeito de nao mandar um boolean
// para o DOM. Filtrando na origem, a interface publica volta a ser boolean e
// camelCase, igual ao resto do componente, e nada vaza para o HTML.
const styleOnlyProps = new Set<string>([
  'isBlackFriday',
  'isHotSite',
  'isFavorite',
  'isFluidMobile',
  'isSearchAndCategory',
])

export const ProductVerticalCard = styled(Link, {
  shouldForwardProp: (prop) => !styleOnlyProps.has(prop),
})<ProductVerticalCardProps>`
  display: flex;
  justify-content: center;
  width: auto;
  height: 100%;
  text-decoration: none !important;
  ${({ isBlackFriday }) =>
    isBlackFriday &&
    css`
      background-color: '#fff';
      border-radius: 0.5rem;
    `}

  > div {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #fff;

    @media (max-width: 480px) {
      padding-top: 0.875rem;
      padding-bottom: 0.875rem;
    }

    ${({ isHotSite, isSearchAndCategory }) =>
      (isHotSite || isSearchAndCategory) &&
      css`
        @media (min-width: 768px) {
          min-width: 15.5rem !important;
        }
      `}

    // O GProductVertical fixa a largura do card no mobile em 10.9375rem, que em
    // telas estreitas é maior que o slide do carrossel: o excedente vaza para os
    // lados (justify-content: center) e sobrepõe o card vizinho. Preencher o
    // slide resolve, e o max-width garante que o card nunca CRESÇA além da
    // largura natural onde o slide já era largo o bastante — ali não havia bug.
    //
    // Sem !important de proposito: o design-system aplica width/minWidth via
    // style props do Chakra, que viram uma classe (especificidade 0,1,0), e este
    // seletor é classe + tipo (0,1,1). A cascata já resolve o desempate, sem
    // depender da ordem de injeção do Emotion nem de !important.
    ${({ isFluidMobile }) =>
      isFluidMobile &&
      css`
        @media (max-width: 767px) {
          width: 100%;
          max-width: 10.9375rem;
          min-width: 0;
        }
      `}

    ${({ isFavorite }) =>
      isFavorite &&
      css`
        @media (min-width: 768px) {
          min-width: 14.5rem !important;
        }
      `}
  }

  // NDC-2615: aqui vivia um reset de font-size no seletor universal, posto como
  // workaround de css global. Como o valor unset numa propriedade herdada
  // equivale a inherit, todo texto do card herdava os 16px do body enquanto o
  // line-height seguia o do tamanho pretendido, sobrepondo as linhas. A regra
  // empatava em especificidade com as classes do design-system, entao vencia ou
  // perdia conforme a ordem de injecao do Emotion, quebrando so onde o
  // componente e carregado via dynamic com ssr desligado. As regras globais de
  // font-size sao em html, button e select (especificidade 0,0,1) e ja perdem
  // para o design-system sem ajuda.

  // TODO after remove ANTD ui then remove this
  // conflict with ANTD css
  p {
    margin: 0;
  }
`
